import { BellAlertIcon } from './BellAlertIcon';

/**
 * author: Simran
 * id 376D7457-2DC3-463A-B4D9-4F170E0B19FB
 * name bell-alert
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-alert.svg
 * tags
 * - Alert / Error 
 * - Notification 
 */
export const BellWarningIcon = BellAlertIcon;
export default BellWarningIcon